import { useState } from "react";
import { Button, FileObjectType, FileUpload, Flex, ModalV2 } from "@jsq/ds/core";
import { FundAdminServiceDocumentType } from "~/graphql/mainEnums";

export type Props = {
  handleUploadDocs: (
    files: FileObjectType[],
    documentsType: FundAdminServiceDocumentType,
  ) => Promise<void>;
  documentsType: FundAdminServiceDocumentType;
  buttonText?: string;
  isCompletedRequest: boolean;
};

export const UploadAdditionalDocsButton = ({
  handleUploadDocs,
  documentsType,
  buttonText,
  isCompletedRequest,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [buttonLoading, setIsButtonLoading] = useState(false);
  const closeModal = () => {
    setIsOpen(false);
  };
  const [files, setFiles] = useState<FileObjectType[]>([]);
  const handleFilesSelected = (selectedFiles: FileObjectType[]) => {
    const acceptedFiles = selectedFiles.filter((file) => file.status === "accepted");
    setFiles(acceptedFiles);
  };

  return (
    <>
      <Button
        disabled={isCompletedRequest}
        variant={"neutral"}
        onClick={() => {
          setIsOpen(true);
        }}
      >
        {buttonText ?? "Upload additional"}
      </Button>
      <ModalV2
        show={isOpen}
        onHide={closeModal}
        isCentered={true}
        backdrop={true}
        title="Upload additional documents"
        visuallyHideTitle
      >
        <Flex flexDirection="column" alignItems={"flex-end"}>
          <FileUpload
            canAllowMultiple
            isFullWidth
            onFileSelected={handleFilesSelected}
            data-testid="upload-additional-docs"
          />
          <Button
            isLoading={buttonLoading}
            onClick={() => {
              setIsButtonLoading(true);
              handleUploadDocs(files, documentsType).finally(() => {
                setIsButtonLoading(false);
                setIsOpen(false);
              });
            }}
            disabled={files.length < 1}
          >
            Save
          </Button>
        </Flex>
      </ModalV2>
    </>
  );
};

export default UploadAdditionalDocsButton;
